"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
var _default = exports.default = {
  getRsmList: function getRsmList() {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/bizOrgInfo/queryAllRsm',
      method: 'post'
    });
  },
  getVisitingList: function getVisitingList(data, cancelToken) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/cp/report/visitRetailorMonthly/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getVisitPlanList: function getVisitPlanList(data, cancelToken) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/cp/report/planTaskWeekly/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getCustomerDistributionList: function getCustomerDistributionList(data, cancelToken) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/cp/report/customerDistribution/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getNetworkExpansionList: function getNetworkExpansionList(data, cancelToken) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/cp/report/expansionStore/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  setLog: function setLog(data) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/sfeTeamPerformanceLog/save',
      method: 'post',
      data: data
    });
  },
  getLog: function getLog(data) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/sfeTeamPerformanceLog/list',
      method: 'post',
      data: data
    });
  },
  exportReportFile: function exportReportFile(url, data) {
    return (0, _request.default)({
      module: 'REPORT',
      url: url,
      method: 'post',
      data: data,
      responseType: 'blob'
    });
  }
};